import React, { Component } from "react";
import { Container } from "reactstrap";
import { NavMenu } from "../components/NavMenu";
import { Outlet } from "react-router-dom";
import TopNavBar from "../components/TopNavBar";
import CrispChat from "../components/CrispChat";
import { AuthProvider } from "../contexts/AccountContext";
import { Toaster } from "react-hot-toast";
import { IntercomProvider, useIntercom } from "react-use-intercom";
import IntercomChat from "../components/IntercomChat";
export class NoSidebarLayout extends Component {
  static displayName = NoSidebarLayout.name;

  render() {
    return (
      <AuthProvider>
        <div>
          <div className="d-flex flex-column flex-lg-row h-lg-full bg-surface-secondary">
            {/* <!-- Content --> */}
            <div className="flex-lg-1 h-screen overflow-y-lg-auto">
              {/* <!-- Navbar --> */}
              <TopNavBar showMenu={false} />
              <Toaster position={"top-right"} />
              {/* <NavMenu /> */}
              {/* <Container>{this.props.children}</Container> */}
              <IntercomProvider appId={"l1nsvmiv"}>
                <Outlet />
                <IntercomChat />
              </IntercomProvider>
            </div>
          </div>
        </div>
      </AuthProvider>
    );
  }
}
